<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="  mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Service Management </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/servicereceipt/index"> Manage Service Receipt  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Service Receipt  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2 ">
  <div  class="card-body custom_bdr_rds">


                    <form @submit.prevent="CreateReceipt()" >

<div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Customer</label>
            <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="squatation.idcustomer"  :options="mcustomers" disabled></v-select>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Receipt Date</label>
            <input  v-model="squatation.receipt_date"   style="font-size: small;" class="form-control font-size_def" disabled>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Payment Mode </label>
            <v-select  @input="LoadMode" class="font-size_def" label="label" v-model="peyment" :options="PaymentMode"></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Bank Slip Image</label>
            <input type="file"     style="font-size: small;" class="form-control font-size_def" >
    </div>
  </div>
  
 
  

  

  
</div>



<div class="row">
    <div v-if="amount" class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Amount</label>
            <input v-model="recept.cash_amount" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
    <div v-if="chequ" class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Cheque Amount</label>
            <input v-model="recept.cheque_amount" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
    <div v-if="chequ" class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Cheque Date</label>
            <input  v-model="recept.cheque_date" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
    <div v-if="chequ" class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Cheque No</label>
            <input v-model="recept.cheque_no" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
  
    <div v-if="bank" class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Bank Name</label>
            <v-select  v-model="recept.bank_name" :options="banks" class="font-size_def" label="bank_name" ></v-select>
    </div>
  </div>

  </div>



  <div v-if="chequ" class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Realised Date</label>
            <input v-model="recept.realized_date" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Bank Code</label>
            <input v-model="recept.bank_code" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Branch Code</label>
            <input v-model="recept.branch_code" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
   
  
    

  </div>






<div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Over Payment</label>
            <input v-model="recept.overpayment_amt" style="font-size: small;" class="form-control font-size_def">
    </div>
  </div>
  
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks</label>
           <textarea v-model="recept.remark" class="form-control" rows="2"></textarea>
    </div>
  </div>
  
  <!-- <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Invoiced Date </label>
            <input type="date" v-model="squatation.invoiced_date"   style="font-size: small;" class="form-control font-size_def" required>
    </div>
  </div> -->
 
  <!-- <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Brand </label>
           
            <v-select class="font-size_def" label="value" v-model="quotation.id_brand"  :options="mbrands"  @input="loadBrand"></v-select>
    </div>
  </div> -->
  
  <!-- <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Payment Method </label>
            <v-select class="font-size_def" label="value" v-model="quotation.payment_method"  :options="paymentmethods" ></v-select>
    </div>
  </div> -->
  <!-- <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Sales Order Type</label>
            <v-select class="font-size_def" label="label"  v-model="so_type" :options="oder_types" ></v-select>
    </div>
  </div> -->
  <!-- <div class="col-md-3">
    <div class="form-group">
            <label class="custom-label" style="font-size: small;">Upload CPO</label>
            <input type="file"   style="font-size: small;" class="form-control font-size_def" >
    </div>
  </div> -->

</div>



<div class="card custom_bdr_rds">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Paid Invoice List</b></h6>

                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Invoice No.</th>
                              <th>Sales Order No.</th>
                              <th>Invoiced Payable Amount</th>
                              <th>Paid Amount</th>
                              <th>Due Amount</th>
                           
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(rec_det, index) in rec_dets" :key="rec_det.id">
                              <td>{{ index + 1 }}</td>
                              <td>{{ rec_det.invoice_num }}</td>
                              <td>{{ rec_det.so_code }}</td>
                              <td>{{ rec_det.invoice_amount }}</td>
                              <td>{{ rec_det.paid_amount }}</td>
                              <td>{{ rec_det.unsettle_amount }}</td>
                             
                              </tr>
                            </tbody>

                          </table>


                        </div>
                    </div>




<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
<h6 class="purchitem mb-2"><b>Receipts for Invoice</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr>
              <th>

              </th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Service Code</label>
                  </div>
                </th>
               
                <th>
                  <div class="form-group custom-form  ">
                    <label class="custom-label2"> Invoice No.</label>
                  </div>
                </th>
               
                <th>
                  <div class="form-group custom-form  required">
                    <label class="custom-label2"> Invoiced Date</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form text_right required">
                    <label class="custom-label2"> Total Payable Amount</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form text_right required">
                    <label class="custom-label2"> Due Amount</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form text_right required">
                    <label class="custom-label2">Payment</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form text_right required">
                    <label class="custom-label2">Balance</label>
                  </div>
                </th>
               
                
              
             
            </tr>
          </thead>
          <tbody>

            <tr v-for="(inv, index) in invs" :key="inv.I_idInvoice">
                <input  type="hidden" v-model="inv.I_idInvoice" style="font-size: small;" class="form-control">
              
              <td   >{{  index+1 }}</td>
              <td >{{ inv.so_code }}</td>
         
              <td >{{ inv.invoice_num }}</td>
            <td >
              {{ inv.invoiced_date }}
            </td>
              
            <td class="text_right">
              {{ inv.total_chargeable_cost }}
            </td>
            <td class="text_right">  {{ inv.bal }}</td>
            <td class="text_right">  
                  <input @input="paymninput(index)" v-model="inv.payment"  type=""  style="font-size: small;" class="form-control">
                </td>
            <td class="text_right">  
                <input  type=""  v-model="inv.lastbal"  style="font-size: small;" class="form-control" disabled>
              </td>
              
              
            </tr>
            
            
            
             
           
           
         


          </tbody>
      </table>

      </div>

</div>
</div>



<br>






    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Update</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){

    this.loadCustomer();
    this.loadAlldata();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        mcustomers:[],
        mproducts:[],
        contacts:[],
        rec_dets:[],
        payinpus:[],
        invs:[],
        banks:[],
        delivery_add:[],
      salespeoples:[

      ],
      squatation:{},
      recept:{},
      totalamt:{},
        customer:{},
        peyment:'Select Payment mode',
        
        // quotation:{},
        //   'so_type':{
        //     label:'Spare Parts',
            
        //   },
       
        sales:{},
      
        quatation_details:[],
        detail:[
      {},  
      ],
      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            // Add more options as needed
        ],

        PaymentMode: [
           
            { label: 'Cash', value: 'Cash' },
            { label: 'Cheque', value: 'Cheque' },
          
            { label: 'Online Transfer', value: 'Online Transfer' },
            // Add more options as needed
        ],
      
        oder_types: [
            { label: 'Spare Parts', value: 'Spare Parts' },
            { label: 'Warranty SO', value: 'Warranty SO' },
         
          
            // Add more options as needed
        ],


        amount:false,
        bank:false,
        chequ:false,
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          async paymninput(id) {

           

            const balString = this.invs[id].bal;
            const bal = balString;
             // const bal = parseFloat(balString.replace(/,/g, ''));
            

              const paymentString = this.invs[id].payment;
              const payment = paymentString;
              //const payment = parseFloat(paymentString.replace(/,/g, ''));

              
        
            if(this.recept.cash_amount >= payment || this.recept.cheque_amount>=payment) {
            
                const last =  bal - payment;
            
             this.invs[id].lastbal = last;
            
 

            }else if( typeof this.recept.cash_amount == 'undefined' && typeof this.recept.cheque_amount=='undefined'){
              alert('Enter Cash or Cheque Payment Amount');
            }else if(isNaN(payment)){
                const last =  bal;
                this.invs[id].lastbal = last;

            }else{
              alert('Invalid, Cannot exceed Total Paid Amount');
            }



          },
    
          async LoadMode() {
           
          if(this.peyment['value']=="Cash"){
           
            this.amount = true;
            this.bank = true;
            this.chequ = false;
          }else if(this.peyment['value']=="Cheque"){
            this.amount = false;
            this.bank = true;
            this.chequ = true;
          }else if(this.peyment['value']=="PD Cheque"){
            this.amount = false;
            this.bank = true;
            this.chequ = true;
          }else if(this.peyment['value']=="Online Transfer"){
            this.amount = true;
            this.bank = true;
            this.chequ = false;
          }


          },
            async loadAlldata() {
       
     
       try {
         const { data} = await  axios.post('/servicereceipts/loaddataupdate',{id:this.id},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
           this.squatation = data.all_data;
           this.recept = data.all_data2;
           this.invs = data.invs;
           this.banks = data.banks;
           this.rec_dets = data.rec_dets;
           this.peyment = data.peyment;

           this.LoadMode();
        //   this.quotation = data.all_data1;
        //   this.sales = data.sales;
        //   this.quatation_details = data.quatation_details;
        //   this.delivery_add = data.delivery_add;
        //   this.totalamt = data.totalamt;
         
       } catch (error) {
         console.log(error.response);
       }
     },

      

    
    async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/mcustomer/customerload',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mcustomers = data.customers;
          this.contacts = data.contacts;
          this.mbrands = data.mbrands;
          this.mproducts = data.mproducts;
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadcontact() {
       
     
       try {
         const { data} = await  axios.post('/servicereceipt/loadcontact',{idcustomer:this.squatation.idcustomer},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.contacts = data.contacts;
          this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

    
    async CreateReceipt() {
       
      

   // console.log("amila");
       try {
         const { data} = await  axios.post('/servicereceipts/update',{id:this.id,userid:this.userid,squatation:this.squatation,peyment:this.peyment,recept:this.recept,invs:this.invs},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
          this.$router.push('/servicereceipt/index');
          }if(data.status=='2000'){
            this.$router.push('/spaymentreceipts/pdindex');
          }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    